<template>
    <div class="calc" id="calc" :class="stateObj">
        <div class="calc__label">{{$t("message.calculator.title")}}</div>
        <div class="calc__tool">
            <div class="calc__tool_controls">
                <div class="calc__tool_control">
                    <span>1</span>
                    <pc-select @changed="onEditionChanged" :options="options" name="edition" v-model="edition">
                        <template v-slot:label>{{$t('message.calculator.edition')}}</template>
                    </pc-select>
                </div>
                <div class="calc__tool_control">
                    <span>2</span>
                    <div class="calc__tool_label">{{$t("message.calculator.users")}}</div>
                    <vue-slider
                            ref="slider"
                            v-model="users"
                            v-bind="sliderOptions"
                            @drag-end="onSliderChanged"
                    ></vue-slider>
                    <div class="calc__tool_value"><input @keyup="checkNumber($event)" maxlength="4" v-model="users" /><span v-if="stateObj.max">+</span></div>
                </div>
                <div class="calc__tool_control" v-if="showDisclaimer">
                    <div class="calc__disclaimer">{{$t("message.calculator.disclaimer")}}</div>
                </div>
            </div>
            <div class="calc__tool_results">
                <div class="results">
                    <div class="results__label">{{$t("message.calculator.estCost")}}</div>
                    <div class="results__set calc--show-set">
                        <div class="results__detail">
                            <div><span>{{$t("message.calculator.contract1")}}</span></div>
                            <div class="results--cost"><span>{{ cost.rate1 }}</span><span>{{$t("message.currencyDesc")}}</span><span>{{$t("message.calculator.term")}}</span></div>
                        </div>
                        <div class="results__detail">
                            <div><span>{{$t("message.calculator.contract3")}}<span>({{$t("message.calculator.contract3savings")}})</span></span></div>
                            <div class="results--cost"><span>{{ cost.rate2 }}</span><span>{{$t("message.currencyDesc")}}</span><span>{{$t("message.calculator.term")}}</span></div>
                        </div>
                    </div>
                    <div class="results__set calc--show-default">
                        <div class="results__empty">
                            <div class="results--cost"><span>{{$t("message.currencySymbol")}}0.00</span><span>{{$t("message.currencyDesc")}}</span><span>{{$t("message.calculator.term")}}</span></div>
                        </div>
                    </div>
                    <div class="results__set calc--show-max">
                        <span>{{$t("message.calculator.volumeDiscount")}}</span>
                    </div>
                    <div class="results__set calc--show-min">
                        <span>{{$t("message.calculator.minUserMsg")}}</span>
                    </div>
                    <div class="results__set calc--show-low">
                        <span>{{$t("message.calculator.lowUserMsg")}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import VueSlider from 'vue-slider-component'
    import pcSelect from './form/Select'
    import 'vue-slider-component/theme/antd.css'
    import Product from '../utils/productSchema'
    import ga from '../../../common/mixins/ga'
    import common from '../../../common/mixins/common'
    import { bus } from '../bus'

    export default {
        name: 'calculator',
        mixins: [ga, common],
        components: {
            VueSlider,
            pcSelect
        },
        data(){
            return {
                edition: "",
                maxUsers: 2500,
                rate: 0,
                defaultUsers: 500,
                defaultEdition: "",
                defaultRate: "",
                users: this.defaultUsers,
                options: this.getOptions(),
                sliderOptions : {
                    dotSize: 20,
                    width: 'auto',
                    height: 4,
                    contained: false,
                    direction: 'ltr',
                    data: null,
                    min: 500,
                    max: 2500,
                    interval: 1,
                    disabled: false,
                    clickable: true,
                    duration: 0.5,
                    adsorb: false,
                    lazy: false,
                    tooltip: 'focus',
                    tooltipPlacement: 'top',
                    tooltipFormatter: void 0,
                    useKeyboard: false,
                    enableCross: true,
                    fixed: false,
                    minRange: void 0,
                    maxRange: void 0,
                    order: true,
                    marks: false,
                    dotOptions: void 0,
                    process: true,
                    dotStyle: void 0,
                    railStyle: void 0,
                    processStyle: void 0,
                    tooltipStyle: void 0,
                    stepStyle: void 0,
                    stepActiveStyle: void 0,
                    labelStyle: void 0,
                    labelActiveStyle: void 0
                }
            }
        },
        computed:{
            showDisclaimer(){
                let allowedLangs = ["en-us", "en-gb", "en-au", "en-in"]
                return (allowedLangs.includes(this.$root.$i18n.locale))
            },
            cost(){
                return{
                    rate1: Product.getCost(this.edition, parseInt(this.users), 0, 1),
                    rate2: Product.getCost(this.edition, parseInt(this.users), 20, 3)
                }
            },
            stateObj(){
                let users = parseInt(this.users)
                let obj = {
                    set: (this.rate > 0 && users >= 500 && users < this.maxUsers),
                    min: (users > 0 && users < 25),
                    low: (users >= 25 && users < 500),
                    max: (users === this.maxUsers && this.rate > 0),
                    overMax: (users > this.maxUsers),
                    default: (this.rate == 0),
                }

                return obj
            },
            gaCalcValue(){
                return `${Product.name} - ${this.edition} (${this.users})`
            }
        },
        mounted() {
            this.users = this.defaultUsers
        },
        created(){
            var self = this
            this.edition = Object.keys(Product.editions)[0]
            this.rate = Product.editions[this.edition].rate

            bus.$on("tierClick", function(value){
                self.onEditionChanged(value)
            })
        },
        methods: {
            onEditionChanged(value){
                this.edition = value
                this.rate = (value != '') ? Product.editions[value].rate : 0
                this.gaTrack(this.gaCalcValue)
            },
            onSliderChanged(){
                this.gaTrack(this.gaCalcValue)
            },
            getOptions(){
                let options = []
                for (let product in Product.editions){
                    options.push({
                        text: product,
                        value: product
                    })
                }
                return options
            },
            checkNumber(e){
                let num = e.target.value.replace(/\D/g,'')
                this.users = (!isNaN(num) && num != "") ? parseInt(num) : num
            }
        }
    }

</script>

<style lang="scss">



</style>